import { render } from "./DetalleCitasPorEspecialidad.vue?vue&type=template&id=10280250&scoped=true"
import script from "./DetalleCitasPorEspecialidad.vue?vue&type=script&lang=js"
export * from "./DetalleCitasPorEspecialidad.vue?vue&type=script&lang=js"

import "./DetalleCitasPorEspecialidad.vue?vue&type=style&index=0&id=10280250&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10280250"]])

export default __exports__